import useSWR from "swr";
import { MIN_RISK_RATING } from "@/constant";
import { StagePaymentServiceFeeZeroType, StagePaymentType } from "commonModule/services/calendar";
import { apiClientCommon } from "services/apiClientCommon";
export type CoverageConfigData = {
  coverage: number;
  fullRefundDays?: number;
  fullRefundHours?: number;
  request_region_promo_code_message: string;
  staged_payment_configuration: StagePaymentType[] | undefined;
  staged_payment: string | null;
  staged_payment_service_fee_zero?: StagePaymentServiceFeeZeroType | undefined;
  pmc_exclude_traveler_insurance?: string;
  currentRiskRatingForIdVerification?: number;
  ach_payment?: string;
  precision_pricing_beyond_days?: number;
  max_cancellation_fee?: number;
  klarna_fee_percentage?: number;
  klarna_fixed_fee?: number;
  klarna_days?: number;
};
const fetcher = async () => {
  const response = await apiClientCommon.getCoverageValue();
  return {
    coverage: Number(response.data.coverage),
    fullRefundDays: Number(response.data.fullRefundDays),
    fullRefundHours: Number(response.data.fullRefundHours),
    request_region_promo_code_message: response.data.request_region_promo_code_message,
    staged_payment_configuration: response.data.staged_payment_configuration,
    staged_payment: response.data.staged_payment,
    staged_payment_service_fee_zero: response.data.staged_payment_service_fee_zero,
    pmc_exclude_traveler_insurance: response.data.pmc_exclude_traveler_insurance || "",
    currentRiskRatingForIdVerification: Number(response.data.currentRiskRatingForIdVerification || MIN_RISK_RATING),
    // if we do not get risk rating, set it to MIN_RISK_RATING
    ach_payment: response.data.ach_payment || "false",
    precision_pricing_beyond_days: Number(response.data.precision_pricing_beyond_days || 29),
    // default to 29 if precision_pricing_beyond_days is not available
    max_cancellation_fee: Number(response.data.max_cancellation_fee || 0),
    klarna_fee_percentage: Number(response.data.klarna_fee_percentage || 0),
    klarna_fixed_fee: Number(response.data.klarna_fixed_fee || 0),
    klarna_days: Number(response.data.klarna_days || 0)
  };
};
const useCalendarCoverage = () => {
  return useSWR("/api/getCalendarCoverage", fetcher, {
    keepPreviousData: true,
    revalidateOnFocus: false,
    dedupingInterval: 3000,
    errorRetryCount: 3
  });
};
export default useCalendarCoverage;